module.exports = __webpack_public_path__ + "img/1.c19e9e38.png";